/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';

class TableBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isOpen: PropTypes.bool,
    };

    state = {
        blank: [['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--']],
    };

    render() {
        const { isOpen } = this.props;
        const { tit, data, url, idx } = this.props.content;
        const { blank } = this.state;

        return (
            <div className={styles.table}>
                <table border="0" className={idx === 1 ? styles.df : ''}>
                    <tbody>
                        <tr>
                            {tit && tit.length > 0 && tit.map && tit.map((item, index) => <th key={index}>{item}</th>)}
                        </tr>
                        {data && data.length > 0 && data.map
                            ? data.map((item, index) => (
                                  <tr
                                      key={index}
                                      className={
                                          idx < 2 && item[2].slice(0, item[2].length - 1) * 1 < 0 ? styles.green : ''
                                      }>
                                      {item.map((_item, index) => {
                                          if (index === 0 && _item) {
                                              return (
                                                  <td key={index}>
                                                      {typeof _item === 'string' ? (
                                                          _item
                                                      ) : _item.name ? (
                                                          <a href={_item.url} rel={rel} target="_blank">
                                                              {_item.name}
                                                          </a>
                                                      ) : (
                                                          <span style={{ color: '#273766' }}>--</span>
                                                      )}
                                                  </td>
                                              );
                                          } else {
                                              return (
                                                  <td key={index}>
                                                      {isOpen && _item ? (
                                                          _item
                                                      ) : (
                                                          <span style={{ color: '#273766' }}>--</span>
                                                      )}
                                                  </td>
                                              );
                                          }
                                      })}
                                  </tr>
                              ))
                            : blank.map((item, index) => {
                                  return (
                                      <tr
                                          key={index}
                                          className={
                                              idx < 2 && item[2].slice(0, item[2].length - 1) * 1 < 0
                                                  ? styles.green
                                                  : ''
                                          }>
                                          {item.map((_item, index) => {
                                              return (
                                                  <td key={index}>
                                                      <span style={{ color: '#273766' }}>--</span>
                                                  </td>
                                              );
                                          })}
                                      </tr>
                                  );
                              })}
                    </tbody>
                </table>
                <a className={styles.more} href={url} rel={rel} target="_blank">
                    更多&gt;&gt;
                </a>
            </div>
        );
    }
}

export default errorBoundary(TableBox);
